import { useState } from 'react';

export const usePromotionalSpaceForm = () => {
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [openTitleDrawer, setOpenTitleDrawer] = useState(false);
  const [openSettingsDrawer, setOpenSettingsDrawer] = useState(false);
  const [openComponentSetting, setOpenComponentSetting] = useState(false);
  const [openProductsDrawer, setOpenProductsDrawer] = useState(false);

  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  const onToggleTitleDrawer = () => setOpenTitleDrawer(!openTitleDrawer);

  const onToggleSettingsDrawer = () =>
    setOpenSettingsDrawer(!openSettingsDrawer);

  const onToggleComponentSetting = () =>
    setOpenComponentSetting((state) => !state);

  const onToggleProductsDrawer = () => setOpenProductsDrawer((state) => !state);

  return {
    openBackgroundDrawer,
    openTitleDrawer,
    openSettingsDrawer,
    openComponentSetting,
    openProductsDrawer,
    onToggleBackgroundDrawer,
    onToggleTitleDrawer,
    onToggleSettingsDrawer,
    onToggleComponentSetting,
    onToggleProductsDrawer,
  };
};
